import React from "react";
import { useHistory } from "react-router-dom";
// Limitless Components
import { Header, TimeSinceFooter } from "@limitless/customer/components";
import { useCreateMessage } from "hooks/create-message-hook/CreateMessageHook";
import CreateNewMessageForm from "../components/create-new-message-form/CreateNewMessageForm";
import Toast from "@limitless/customer/components/toast/Toast";

const NewMessageScreen = () => {
    const { toggleAppOpen } = useCreateMessage();
    const history = useHistory();

    return (
        <div className="llm-view-container">
            <Header
                title="New Question"
                onLeftIconClickHandle={() => history.push("/history")}
                onCloseHandle={toggleAppOpen}
            />
            <Toast />
            <CreateNewMessageForm />
            <TimeSinceFooter />
        </div>
    );
};

export default NewMessageScreen;
